import type {
  Renegociacao, SolicitarRenegociacaoCommand, RenegociacaoDecisaoCommand, RenegociacaoStatus,
} from '@/domain/model/Renegociacao';
import type { Page } from '@/domain/model/Page';
import type { RenegociacaoGateway } from '@/application/port/out/RenegociacaoGateway';
import type {
  ListRenegociacoesUseCase, SolicitarRenegociacaoUseCase, DecidirRenegociacaoUseCase,
} from '@/application/port/in/RenegociacaoUseCase';

export class ListRenegociacoes implements ListRenegociacoesUseCase {
  constructor(private readonly g: RenegociacaoGateway) {}
  execute(p: { status?: RenegociacaoStatus; parcelaId?: string; page?: number; size?: number }): Promise<Page<Renegociacao>> {
    return this.g.list(p);
  }
}
export class SolicitarRenegociacao implements SolicitarRenegociacaoUseCase {
  constructor(private readonly g: RenegociacaoGateway) {}
  execute(c: SolicitarRenegociacaoCommand): Promise<Renegociacao> { return this.g.solicitar(c); }
}
export class DecidirRenegociacao implements DecidirRenegociacaoUseCase {
  constructor(private readonly g: RenegociacaoGateway) {}
  execute(id: string, c: RenegociacaoDecisaoCommand): Promise<Renegociacao> { return this.g.decidir(id, c); }
}
